import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Permitir solicitudes que no son a la API (assets, i18n, etc.)
    if (!request.url.startsWith(environment.apiEndpoint)) {
      return next.handle(request);
    }

    // Endpoints públicos de la API
    const publicEndpoints = [
      `${environment.apiEndpoint}auth/login`,
      `${environment.apiEndpoint}auth/recuperar`,
      `${environment.apiEndpoint}auth/codigo`,
      `${environment.apiEndpoint}auth/changePassword`,
      `${environment.apiEndpoint}images`,
      `${environment.apiEndpoint}perfil/tarjeta/codigo/`,
      `${environment.apiEndpoint}tarjeta/codigo/`,
      `${environment.apiEndpoint}api/notifications`,
      `${environment.apiEndpoint}qrcode/`,
      `${environment.apiEndpoint}wallet/google/`,
      `${environment.apiEndpoint}auth/createClientUser`,
      `${environment.apiEndpoint}auth/createTempClientUser`,
      `${environment.apiEndpoint}network/client/`,
      `${environment.apiEndpoint}beneficios/validar-canje/`
    ];

    if (publicEndpoints.some(url => request.url.includes(url)) || new RegExp(`${environment.apiEndpoint}taller/\\d+$`).test(request.url)) {
      return next.handle(request);
    }

    if (!this.isBrowser()) {
      return next.handle(request);
    }

    const token = localStorage.getItem('authToken');

    if (!token) {
      this.router.navigate(['/authentication/login']);
      return new Observable<HttpEvent<any>>();
    }

    if (token) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !this.isRefreshing) {
          this.isRefreshing = true;

          // Intentar renovar el token
          return this.authService.refreshToken().pipe(
            switchMap((response) => {
              this.isRefreshing = false;

              // Guardar el nuevo token
              this.authService.saveToken(response.token);

              // Reintentar la solicitud original con el nuevo token
              return next.handle(
                request.clone({
                  setHeaders: { Authorization: `Bearer ${response.token}` },
                })
              );
            }),
            catchError((err) => {
              this.isRefreshing = false;
              console.error('No se pudo renovar el token. Redirigiendo al login...');
              this.router.navigate(['/authentication/login']);
              return throwError(() => err);
            })
          );
        }

        // Otros errores
        return throwError(() => error);
      })
    );
  }
}
